export default "__VITE_ASSET__DaxafzFP__"